export default {
  required: "Field is required",
  lessThan10: "Field must be less than 10 characters",
  lessThan100: "Field must be less than 100 characters",
  lessThan250: "Field must not exceed 250 characters",
  lessThan256: "Field must be less than 256 characters",
  lessThan5000: "Field must be less than 5000 characters",
  moreThan3: "Field must be more than 3 characters",
  isHex: "Field must be a hexademical value",
  isEmail: "Field must be a valid e-mail address",
  isInteger: "Field must be a valid integer number",
  atLeast1: "Fill in at least one element",
  noSpecialCharacters: "No special characters allowed",
  onlyNumberWithDotsAndComma: "Field must be a decimal number",
  onlyNumberWithDotsAndCommaAndPrefixSign: "Field must be positive or negative decimal number",
  objectWithKey: "Field is required",
  authentication: {
    validAuthentication: "Invalid Authentication data",
  },
}
